import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import ThemeColors from './ThemeColors';
import * as strings from '../helpers/strings';

const styles = {
  root: {display: "flex", color: ThemeColors.primary}
}

const AppName = ({ color = null, classes, name = null }) => <span className={classes.root} style={color ? { color } : null}>{name || strings.appName}</span>;

AppName.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(AppName);